module.exports = __webpack_public_path__ + "static/media/face3.9f4dd43c.jpg";